import * as componentKeyConstants from "constants/ComponentKeyConstants";
import { atom, selectorFamily } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import { isNullOrEmpty } from "shared/Helpers";

export const fnolThirdPartyState = atom({
  key: "fnolThirdPartyState",
  default: { thirdPartyArray: [], autoPopulatedBy: "" },
});

// will be used was the tp on property change work is fully implemented. MB.
export const tpOnPropertyChangeTriggeredByData = atom({
  key: "tpOnPropertyChangeTriggeredByData",
  default: {},
});

// will be used was the tp on property change work is fully implemented. MB.
export const getTPOnPropertyChangeTriggeredByDataForSpecificTP = selectorFamily({
  key: "getTPOnPropertyChangeTriggeredByDataForSpecificTP",
  get:
    (tpId) =>
    ({ get }) => {
      const triggeredByData = get(tpOnPropertyChangeTriggeredByData);
      const relevantTriggeredByData = Object.entries(triggeredByData).filter((item) => item[0].includes(tpId));
      return relevantTriggeredByData;
    },
});

// Maybe be used for the coming tp work. MB.
// export const getTPOnPropertyChangeDataForSpecificTPField = selectorFamily({
//   key: "getTPOnPropertyChangeDataForSpecificTPField",
//   get:
//     (fieldPath) =>
//     ({ get }) => {
//       const changes = get(tpOnPropertyChangeData);
//       const relevantChanges = [];

//       for (const change of changes ?? []) {
//         if (change.doesChangeAssignField(fieldPath)) {
//           relevantChanges.push(change);
//         }
//       }

//       return relevantChanges.length > 0 ? relevantChanges.slice(-1)[0] : null;
//     },
// });

export const getThirdPartyValueForTPField = selectorFamily({
  key: "getThirdPartyValueForTPField",
  get:
    ([componentKey, tpId]) =>
    ({ get }) => {
      const thirdPartyObj = get(fnolThirdPartyState);
      const relevantTP = thirdPartyObj.thirdPartyArray.find((tp) => tp.key === tpId);
      if (!relevantTP) {
        return null;
      }
      return relevantTP.thirdPartyValues[componentKey] ?? null;
    },
});

export const setFnolThirdPartyState = (thirdParties) => {
  if (!isNullOrEmpty(thirdParties)) {
    const triggeredByData = getRecoil(tpOnPropertyChangeTriggeredByData);
    let tpArray = [];
    for (let i = 0; i < thirdParties.length; i++) {
      const newThirdPartyObj = { key: thirdParties[i].thirdPartyId, thirdPartyValues: thirdParties[i] };
      tpArray.push(newThirdPartyObj);
    }
    setRecoil(fnolThirdPartyState, { thirdPartyArray: tpArray, autoPopulatedBy: triggeredByData });
  }
};

export const getFnolThirdPartyArrayWithKeyState = (value) => {
  return new Promise(async (resolve) => {
    let tpArray = [];
    if (!isNullOrEmpty(value)) {
      for (let i = 0; i < value.thirdPartyArray.length; i++) {
        const newThirdPartyObj = {
          key: value.thirdPartyArray[i].thirdPartyId,
          thirdPartyValues: value.thirdPartyArray[i],
        };
        tpArray.push(newThirdPartyObj);
      }
    }
    resolve(tpArray);
  });
};

export const getFnolThirdPartyArrayState = () => {
  const theThirdPartyObj = getRecoil(fnolThirdPartyState);
  const triggeredByData = getRecoil(tpOnPropertyChangeTriggeredByData);
  return new Promise(async (resolve) => {
    let tpArray = [];
    for (let i = 0; i < theThirdPartyObj.thirdPartyArray.length; i++) {
      tpArray.push(theThirdPartyObj.thirdPartyArray[i].thirdPartyValues);
    }
    resolve({ thirdPartyArray: tpArray, autoPopulatedBy: triggeredByData });
  });
};

export const updateTPOnPropertyChangeTriggeredByData = (fieldPath, triggeredBy) => {
  setRecoil(tpOnPropertyChangeTriggeredByData, (currentState) => {
    const newState = { ...currentState };
    if (triggeredBy === null) {
      delete newState[fieldPath];
    } else {
      newState[fieldPath] = triggeredBy;
    }
    return newState;
  });
};

export const RemoveTPTriggeredByData = (tpId) => {
  setRecoil(tpOnPropertyChangeTriggeredByData, (currentState) => {
    const newState = { ...currentState };
    for (const key in Object.keys(newState))
      if (key.includes(tpId)) {
        delete newState(key);
      }
    return newState;
  });
};

// Will later be used to indicate which tp fields have auto-pop rules as well as the hard coded vrn change.
export const tpFieldHasOnPropertyChange = (tpField) => {
  return tpField === componentKeyConstants.VehicleRegistration;
};
